import React, { useEffect, useState } from "react";
import PageHero from "@/components/public/PageHero";
import api from "@/lib/api";

const IMPACT = {
  high: { label: "High", cls: "bg-red-100 text-red-700 border-red-200" },
  medium: { label: "Medium", cls: "bg-amber-100 text-amber-700 border-amber-200" },
  low: { label: "Low", cls: "bg-slate-100 text-slate-600 border-slate-200" },
};

export function ImpactBadge({ impact }) {
  const i = IMPACT[impact] || IMPACT.low;
  return <span className={`text-xs px-2.5 py-1 rounded-full border font-medium ${i.cls}`} data-testid={`impact-${impact}`}>{i.label}</span>;
}

export default function EconomicCalendar() {
  const [events, setEvents] = useState([]);
  const [filter, setFilter] = useState("all");
  useEffect(() => { api.get("/content/events?published_only=true").then((r) => setEvents(r.data)).catch(() => {}); }, []);

  const sorted = [...events].sort((a, b) => new Date(a.date) - new Date(b.date));
  const shown = filter === "all" ? sorted : sorted.filter((e) => e.impact === filter);

  return (
    <div>
      <PageHero overline="Market Research" title="Economic Calendar" subtitle="Upcoming market-moving events with expected impact, forecasts and previous readings." image="/images/hero_global_finance.jpg" />
      <section className="py-14 sm:py-20 bg-white">
        <div className="cb-container">
          <div className="flex flex-wrap gap-2 mb-6">
            {[["all", "All"], ["high", "High"], ["medium", "Medium"], ["low", "Low"]].map(([v, l]) => (
              <button key={v} onClick={() => setFilter(v)} className={`px-4 py-2 text-sm rounded transition-colors ${filter === v ? "btn-gold" : "text-slate-600 border border-slate-200 hover:border-[#D8AE4E]/60"}`} data-testid={`calendar-filter-${v}`}>{l}</button>
            ))}
          </div>
          {shown.length === 0 ? <p className="text-slate-500">No events scheduled.</p> : (
            <div className="cb-card overflow-x-auto admin-scroll">
              <table className="w-full text-sm min-w-[640px]">
                <thead><tr className="text-left text-slate-500 border-b border-slate-200">
                  <th className="px-6 py-3 font-medium">Date</th><th className="px-6 py-3 font-medium">Cur.</th><th className="px-6 py-3 font-medium">Event</th><th className="px-6 py-3 font-medium">Impact</th><th className="px-6 py-3 font-medium text-right">Forecast</th><th className="px-6 py-3 font-medium text-right">Previous</th>
                </tr></thead>
                <tbody>
                  {shown.map((e) => (
                    <tr key={e.id} className="border-b border-slate-200 last:border-0 hover:bg-[#F8FAFC] transition-colors" data-testid={`event-row-${e.id}`}>
                      <td className="px-6 py-4 font-mono text-slate-600 whitespace-nowrap">{e.date ? new Date(e.date).toLocaleDateString(undefined, { day: "2-digit", month: "short", weekday: "short" }) : "—"}</td>
                      <td className="px-6 py-4 font-mono text-[#0B1D40]">{e.currency}</td>
                      <td className="px-6 py-4 text-[#0B1D40]">{e.title}</td>
                      <td className="px-6 py-4"><ImpactBadge impact={e.impact} /></td>
                      <td className="px-6 py-4 font-mono text-slate-600 text-right">{e.forecast || "-"}</td>
                      <td className="px-6 py-4 font-mono text-slate-500 text-right">{e.previous || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <p className="text-xs text-slate-400 mt-4">Calendar entries are managed in the admin panel and are indicative; verify against your platform's live calendar.</p>
        </div>
      </section>
    </div>
  );
}
